module.exports = __webpack_public_path__ + "images_/biz-micro-services-ui/project/middlePlatform/asset/rank_v15.png";


//////////////////
// WEBPACK FOOTER
// ../biz-micro-services-ui/project/middlePlatform/asset/rank_v15.png
// module id = 1605
// module chunks = 418